import { FC, ReactNode, useRef } from "react";
import { createPortal } from "react-dom";
import {usePortal} from "../../../util/usePortal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faX} from "@fortawesome/pro-solid-svg-icons";
import {faFolder, faPage} from "@fortawesome/pro-regular-svg-icons";

type AddPortalProps = {
  trigger: ReactNode;
  onAddPage: () => void;
  onAddFolder: () => void;
};

export const AddPortal: FC<AddPortalProps> = ({trigger, onAddPage, onAddFolder,}) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const {isOpen, open, close, menuRef, position,} = usePortal(triggerRef, {placement: "right"});

  return <>
      <div ref={triggerRef} onClick={(e) => {
          e.stopPropagation();
          open();
        }}>
        {trigger}
      </div>

      {isOpen &&
        createPortal(
          <div ref={menuRef} className="fixed z-20 bg-white border border-slate-200 rounded-md" style={{top: position.top, left: position.left,}}>
            <div className="flex flex-col">
              <div className="px-2 py-1.5 hover:bg-brand-50 cursor-pointer" onClick={() => {
                  close();
                  onAddPage();
                }}>
                <div className={'flex flex-row space-x-2 items-center'}>
                  <FontAwesomeIcon icon={faPage} />
                  <div>Pagina</div>
                </div>
              </div>

              <div className="px-2 py-1.5 hover:bg-brand-50 cursor-pointer" onClick={() => {
                  close();
                  onAddFolder();
                }}>
                <div className={'flex flex-row space-x-2 items-center'}>
                  <FontAwesomeIcon icon={faFolder} />
                  <div>Folder</div>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
};